import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "turnitin",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-settings" */ "./components"),
        import(/* webpackChunkName: "admin-settings" */ "./modules/Module"),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "turnItInSettings",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
